module.exports = __webpack_public_path__ + "static/media/XBOX4.91cc240e.png";